function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet, color, spacing } from "../../../../styles/theme";
var _t = function _t(t) {
  return t;
};
var pulsateKeyFrames = {
  '0%': {
    transform: 'scale(.1)',
    opacity: 0
  },
  '40%': {
    opacity: 1
  },
  '100%': {
    transform: 'scale(1)',
    opacity: 0
  }
};
var styles = StyleSheet.create({
  SvgLoaderSignal: {
    position: 'relative'
  },
  loader: {
    textIndent: '-9999em',
    borderStyle: 'solid',
    margin: "".concat(spacing.md, " 0 0 ").concat(spacing.md),
    opacity: 0,
    position: 'absolute',
    top: "-".concat(spacing.md),
    left: "-".concat(spacing.md),
    animationName: [pulsateKeyFrames],
    animationDuration: '1s',
    animationIterationCount: 'infinite'
  }
});

// TODO[Audrey]: WIP
var SvgLoaderSignal = function SvgLoaderSignal(_ref) {
  var _ref$htmlAttributes = _ref.htmlAttributes,
    htmlAttributes = _ref$htmlAttributes === void 0 ? {} : _ref$htmlAttributes,
    _ref$style = _ref.style,
    style = _ref$style === void 0 ? {} : _ref$style,
    isThemeDark = _ref.isThemeDark,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    fillAlt = _ref.fill,
    _ref$borderWidth = _ref.borderWidth,
    borderWidth = _ref$borderWidth === void 0 ? '0.2em' : _ref$borderWidth;
  var fill = fillAlt || (isThemeDark ? color.white : color.primary);
  return /*#__PURE__*/React.createElement("div", _extends({}, htmlAttributes, css(styles.SvgLoaderSignal), {
    style: _objectSpread({
      width: size,
      height: size
    }, style)
  }), /*#__PURE__*/React.createElement("div", _extends({}, css(styles.loader), {
    style: {
      width: size,
      height: size,
      borderRadius: size,
      borderColor: fill,
      borderWidth: borderWidth
    }
  }), _t('Loading...')));
};
SvgLoaderSignal.propTypes = {
  /**
   * Override the inline-styles of the root element
   */
  style: PropTypes.object,
  /**
   * Additional control for the root element, can add data-courselenium, ariaLabel...
   */
  htmlAttributes: PropTypes.object,
  /**
   * Whether component has dark bg parent element
   */
  isThemeDark: PropTypes.bool,
  size: PropTypes.number,
  fill: PropTypes.string,
  borderWidth: PropTypes.number
};
SvgLoaderSignal.displayName = 'SvgLoaderSignal';
export default SvgLoaderSignal;